module.exports = __webpack_public_path__ + "img/824.3b023366.gif";